<template>
  <div class="batch" v-show="batch.activityName">
    <div class="name">
      <back-page />
      <h3>{{ batch.activityName }}</h3>
      <el-input
        v-model="inputValue"
        style="width: 250px"
        size="small"
        placeholder="输入岗位名称，enter键检索"
        clearable
        @keydown.enter="searchJobList"
      />
    </div>
    <!-- <div class="info">简介：{{ batch.discription }}</div>
    <div class="info">
      报名时间：{{ formatDate('YYYY年MM月DD日', new Date(batch.startTime)) }}~{{ formatDate('YYYY年MM月DD日', new Date(batch.endTime)) }}
    </div> -->
  </div>
  <!-- 卡片式岗位列表 -->
  <div class="job_list">
    <div class="job_item" v-for="item in jobList" :key="item.id">
      <div class="name" @click="item.showMore = !item.showMore">
        {{ item.jobName }}
      </div>
      <div class="info" v-if="isSpecific">
        <div class="info_dept mr20">招聘单位：{{ item.deptName }}</div>
        <div class="info_num mr20">招聘人数：{{ item.needNum }}人</div>
        <div class="info_num mr20">已投递人数：{{ item.applicantNum || 0 }}人</div>
        <div class="info_num">已通过审核人数：{{ item.passNum || 0 }}人</div>
      </div>
      <div class="info" v-else>
        <div class="info_dept mr20">招聘部门：{{ item.deptName }}</div>
        <div class="info_edu mr20">学历要求：{{ item.educationNeed }}</div>
        <div class="info_num mr20" v-if="item.remark">是否应届：{{ item.remark }}</div>
        <div class="info_num">招聘人数：{{ item.needNum }}人</div>
        <div class="info_num">已投递人数：{{ item.applicantNum || 0 }}人</div>
      </div>
      <div class="more" :class="{ active: !!item.showMore }" @click="item.showMore = !item.showMore">
        <span>{{ item.showMore ? '收起' : '查看更多' }}</span
        ><ArrowRightBold />
      </div>
      <div class="info desc" v-show="item.showMore">
        <p class="title">岗位描述：</p>
        <p>{{ item.jobDescription || '无' }}</p>
      </div>
      <div class="info desc" v-show="item.showMore">
        <p class="title">岗位要求：</p>
        <p>{{ item.jobNeed.replaceAll(' ', '&nbsp;') || '无' }}</p>
      </div>
      <div class="actions">
        <slot v-if="batch.status === 1">
          <el-button v-if="isSpecific && deliverJob" type="primary" disabled size="small">岗位已投递</el-button>
          <el-button v-else type="primary" size="small" @click="deliverFunc(item)">投递岗位 </el-button>
        </slot>
        <el-button v-else-if="batch.status === 3" type="primary" size="small" disabled>报名未开始</el-button>
        <el-button v-else-if="batch.status === 4" type="primary" size="small" disabled>报名已结束</el-button>
        <el-button v-else type="primary" size="small" disabled>招聘已结束</el-button>
      </div>
    </div>
    <div v-if="!loading && !jobList.length">暂无岗位信息</div>
  </div>
  <!-- 分页 -->
  <el-pagination
    class="pagination"
    v-show="pagination.total > pagination.pageSize"
    background
    layout="prev, pager, next"
    :current-page="pagination.currentPage"
    :page-size="pagination.pageSize"
    :total="pagination.total"
    @current-change="(currentPage) => (pagination.currentPage = currentPage)"
  />
  <el-dialog v-model="visible" :title="'投递岗位：' + selectedJob.jobName" :width="1000" top="10vh">
    <div class="deliverModal">
      <!-- <p>请注意，每轮招聘仅限投递一个岗位，简历越完整通过率越高，<span style="color: red">红色为必填项！</span></p> -->
      <Preview v-model="resume" :isSpecific="isSpecific" :job="selectedJob" />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" size="medium" @click="cancelFunc">取消</el-button>
        <!-- <el-button size="medium" type="info" @click="router.push('/resume')">编辑</el-button> -->
        <el-button type="primary" size="medium" @click="confirmFunc">投递</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { onActivated, onDeactivated, onMounted, reactive, toRefs, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ArrowRightBold } from '@element-plus/icons';
import { ElMessage } from 'element-plus';

import BackPage from '../components/BackPage.vue';
import ApplicantApi from '../service/api/applicant';
import { formatDate } from '../utils/tools';
import router from '../router';
import Preview from './resume/Preview.vue';

export default {
  name: 'Job',
  components: { ArrowRightBold, BackPage, Preview },
  setup() {
    const state = reactive({
      resume: null,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      inputValue: '', // 搜索框的值
      searchValue: '', // 上一次搜索的值
      batch: {
        activityId: null, // 当前招聘批次ID
      },
      jobList: [],
      visible: false,
      selectedJob: {},
      deliverJob: null,
      loading: true,
    });

    const getJobList = async () => {
      state.loading = true;
      state.searchValue = state.inputValue || '';
      try {
        const respond = await ApplicantApi.getJobList({
          activityId: state.batch.activityId,
          pageNum: state.pagination.currentPage,
          pageSize: state.pagination.pageSize,
          jobName: state.searchValue,
        });
        state.pagination.total = respond.jobs.total;
        state.jobList = respond.jobs.list || [];
        state.batch = Object.assign({}, state.batch, respond);
      } catch (e) {
        state.pagination.total = 0;
        state.jobList = [];
        state.batch = {};
      }

      state.loading = false;
      window.scrollTo(0, 0);
    };
    watch([() => state.pagination.currentPage, () => state.pagination.pageSize], () => getJobList());
    const searchJobList = () => {
      // 搜索时currentPage重置为1
      // currentPage变化，会监听修改更新joblist
      if (state.pagination.currentPage !== 1) {
        state.pagination.currentPage = 1;
      } else {
        getJobList();
      }
    };
    watch([() => state.inputValue], ([nVal]) => {
      if (!nVal && nVal !== state.searchValue) searchJobList();
    });

    const route = useRoute();
    const init = async () => {
      if (!route.query.activityId) {
        try {
          const respond = await ApplicantApi.getBatchList({
            pageNum: 1,
            pageSize: 1,
          });
          state.batch.activityId = respond.list[0].activityId;
        } catch (e) {
          state.batch = {};
          state.pagination.total = 0;
          state.jobList = [];
        }
      } else {
        state.batch.activityId = route.query.activityId;
      }
      getJobList();
    };
    // 页面被激活时，批次ID改变更新页面
    onActivated(() => {
      if ((route.query.activityId || state.batch.activityId) && route.query.activityId !== state.batch.activityId) {
        init();
      }
      getDeliverList();
    });
    onDeactivated(() => {
      state.visible = false;
    });
    onMounted(init);

    const store = useStore();
    const deliverFunc = async (item) => {
      const { userInfo, isMobile } = store.state;
      if (isMobile) {
        return ElMessage.warning('为了更好地体验，请在PC端登录投递');
      }
      if (!userInfo || !userInfo.userId) {
        return store.commit('SET_SHOWLOGIN', true);
      }
      if (!userInfo.basicId) {
        ElMessage.warning('先填写简历再投递');
        return setTimeout(() => {
          router.push('/resume');
        }, 1000);
      }
      if (userInfo && userInfo.userId) {
        const respond = await ApplicantApi.getResume({
          userId: userInfo.userId,
        });
        state.resume = respond[respond.length - 1] || {};
        state.visible = true;
        state.selectedJob = item;
      }
    };
    const confirmFunc = async () => {
      const { userInfo } = store.state;
      try {
        await ApplicantApi.deliverResume({
          activityId: +state.batch.activityId,
          jobId: +state.selectedJob.jobId,
          userId: userInfo.userId,
          basicId: userInfo.basicId,
        });
        ElMessage.success('投递成功');
        state.visible = false;
        getDeliverList();
      } catch (e) {
        console.error('投递失败', e);
      }
    };
    const cancelFunc = () => {
      state.visible = false;
    };

    let timer = null;
    const getDeliverList = () => {
      if (timer) return;
      timer = setTimeout(async () => {
        clearTimeout(timer);
        timer = null;
        const userInfo = store.state.userInfo;
        if (userInfo && userInfo.basicId) {
          try {
            const respond = await ApplicantApi.getMyDeliver(userInfo.basicId);
            state.deliverJob = respond[0] || null;
          } catch {
            state.deliverJob = null;
          }
        }
      }, 100);
    };

    const dicOptions = computed(() => store.state.dicOptions);
    const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
    return {
      router: useRouter(),
      ...toRefs(state),
      getJobList,
      searchJobList,
      formatDate,
      confirmFunc,
      cancelFunc,
      deliverFunc,
      dicOptions,
      isSpecific,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../style/func.scss';
.batch {
  border-bottom: 2px solid rgba(112, 112, 112, 0.1);
  padding: rem(10px) rem(10px) rem(6px) rem(10px);
  .name {
    height: rem(40px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // border-bottom: 1px solid rgba(102, 102, 102, 0.1);
    font-size: rem(16px);
    h3 {
      flex: 1;
    }
  }
  .info {
    margin-top: rem(12px);
    padding: rem(6px) rem(10px);
    font-size: rem(16px);
    color: #363e4f;
  }
  .count {
    color: #318eef;
  }
}

.job_list {
  padding: rem(20px) rem(30px);
  min-height: 700px;
  font-size: rem(16px);
  .job_item {
    border-radius: rem(4px);
    border: 1px solid rgba(102, 102, 102, 0.1);
    box-shadow: 0 2px 4px #f9f9f9;
    margin-bottom: rem(20px);
    position: relative;
    overflow: hidden;
    white-space: break-spaces;
    &:hover {
      background: #f9f9f9;
    }
    .name {
      margin-bottom: rem(6px);
      padding: 0 rem(20px);
      height: rem(40px);
      color: #ed4013;
      border-bottom: 1px solid #f7f7f7;
      font-size: rem(18px);
      display: flex;
      align-items: center;
    }
    .info {
      padding: rem(6px) rem(20px);
      font-size: rem(16px);
      color: #363e4f;
      display: flex;
      align-items: center;
      line-height: rem(24px);
      flex-wrap: wrap;
      .mr20 {
        margin-right: rem(20px);
      }
      > div {
        display: inline-block;
      }
      &_dept {
        width: 28%;
      }
      &_edu {
        width: 25%;
      }
      &_num {
        width: 20%;
      }
      &.desc {
        font-size: rem(14px);
        display: block;
        .title {
          font-weight: 600;
          margin-bottom: rem(6px);
          font-size: rem(16px);
        }
      }
    }
    .more {
      position: absolute;
      right: rem(20px);
      top: rem(10px);
      color: #318eef;
      cursor: pointer;
      font-size: rem(14px);
      display: flex;
      align-items: center;
      svg {
        margin-left: rem(4px);
        width: rem(14px);
        transition: transform 0.3s;
      }
      &.active {
        svg {
          transform: rotate(90deg);
        }
      }
    }
    .actions {
      padding: 0 rem(10px);
      height: rem(46px);
      border-top: 1px solid #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .status {
      position: absolute;
      right: rem(-100px);
      top: rem(30px);
      width: rem(300px);
      height: rem(46px);
      background: #2cb6f4;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem(26px);
      transform: rotate(45deg);
    }
  }
}

.pagination {
  padding-bottom: rem(20px);
  text-align: center;
  i {
    margin: 0 auto;
  }
}

.deliverModal {
  padding: 0 rem(40px);
  overflow: auto;
  height: 60vh;
  // font-size: rem(17px);
  > div {
    margin-bottom: rem(6px);
    span {
      cursor: pointer;
      color: #ed4013;
    }
  }
  p {
    font-size: rem(14px);
    color: #318eef;
  }
}

@media screen and (max-width: 600px) {
  .batch {
    .name {
      font-size: rem(12px);
      :deep(.el-input) {
        display: none;
      }
    }
    .info {
      font-size: 0.14rem;
    }
  }

  .job_list {
    padding: rem(20px);
    font-size: rem(14px);
    .job_item {
      .name {
        font-size: rem(14px);
        padding: 0 rem(6px);
      }
      .info {
        font-size: rem(14px);
        display: block;
        > div {
          width: 100%;
          margin-right: 0;
        }
        &.desc {
          font-size: rem(12px);
          display: block;
          .title {
            font-size: rem(12px);
          }
        }
      }
      .more {
        top: rem(12px);
        span {
          display: none;
        }
      }
    }
  }
}
</style>
